class MasonryGrid extends HTMLElement {
  #resizeObserver;
  #layoutPending = false;

  connectedCallback() {
    requestAnimationFrame(() => this.#layout());

    this.#resizeObserver = new ResizeObserver(() => {
      if (this.#layoutPending) return;
      this.#layoutPending = true;
      requestAnimationFrame(() => {
        this.#layout();
        this.#layoutPending = false;
      });
    });
    this.#resizeObserver.observe(this);
  }

  disconnectedCallback() {
    this.#resizeObserver?.disconnect();
  }

  #layout() {
    const items = [...this.children];
    if (!items.length) return;

    this.style.gridAutoRows = '';
    this.style.rowGap = '';
    this.style.alignItems = 'start';
    items.forEach(item => (item.style.gridRowEnd = ''));

    const gap = parseFloat(getComputedStyle(this).rowGap) || 0;
    const heights = items.map(item => item.getBoundingClientRect().height);

    this.style.gridAutoRows = '1px';
    this.style.rowGap = '0px';

    items.forEach((item, i) => {
      item.style.gridRowEnd = `span ${Math.ceil(heights[i] + gap)}`;
    });
  }
}

if (!customElements.get('masonry-grid')) {
  customElements.define('masonry-grid', MasonryGrid);
}
